

























import { Vue, Prop, Component } from "vue-property-decorator";
import { GlobalOnlyUploadService } from "@common/service/data-service/upload";
import RingProgress from "./RingProgress.vue";
import {uploadFileWebSiteApi, uploadBiddingFileApi} from "@common/api/upload";

@Component({
  components: {
    RingProgress
  }
})
export default class UploadFile extends Vue {
  @Prop({ default: "上传附件" })
  btnText!: string;
  @Prop({ default: "多个文件请打包上传,文件限制20M,支持PDF、WORD、ZIP等格式" })
  tipText!: string;
  @Prop({ default: 1 })
  limit!: number;
  @Prop({})
  accept!: string;
  @Prop({ default: 0 })
  size!: number;
  @Prop({ default: "uploadFileWebSiteApi"})
  fileUploadApi!: string;

  fileList: any[] = [];
  fileListName: any[] = [];
  beforeUpload(file: any) {
    const imgSize = Number(file.size / 1024 / 1024);
    if(this.accept.indexOf(file.name.split('.').pop())==-1){
      this.$msgbox({
        title: "",
        message: `不支持该文件类型`,
        type: "warning"
      });
      return false
    }

    if (this.size !== 0 && imgSize > this.size) {
      this.$msgbox({
        title: "",
        message: `文件大小不能超过${this.size}MB，请重新上传。`,
        type: "warning"
      });
    } else {
      this.fileListName = [];
      this.fileList = [];

      const obj = {
        name: file.name,
        progress: 0
      };
      this.fileListName.push(obj);
      const index = this.fileListName.length - 1;
      const apis = {
        "uploadFileWebSiteApi": uploadFileWebSiteApi,
        "uploadBiddingFileApi": uploadBiddingFileApi
      };
      console.log("api: " + this.fileUploadApi);
      GlobalOnlyUploadService.upload(file, "1", progress => {
        if (!GlobalOnlyUploadService.isStop) {
          this.fileListName[index].progress = progress;
        }
      }, apis[this.fileUploadApi])
        .then((res: any) => {
          const obj = {
            name: res.name,
            url: res.url,
            id: res.id
          };
          this.fileList.push(obj);
          this.$emit("success", this.fileList);
        })
        .catch(() => {
          //
        });
    }
    return false;
  }
  handleRemove(progress) {
    this.fileListName = [];
    if (progress < 100) {
      GlobalOnlyUploadService.isStop = true;
    } else {
      this.fileList = [];
      this.$emit("remove");
    }
  }
}
